import { SECRET_KEY } from '@shared/helpers/env';

function encrypt(token) {
  return btoa(btoa(SECRET_KEY) + token + btoa(SECRET_KEY));
}

export default encrypt;
